export const EDIT_AD_PAGE_SLUG_INDEX = 3;
export const SINGLE_AD_PAGE_SLUGS_COUNT = 3;
